<template>
  <div
    class="lms-wrapper-two"
  >

  <student-nav ></student-nav>
  <div class="lms-content">
    <student-header class="filled" @toggle-navbar="toggleNavbar($event)" />
    <div class="lms-content-body container" style="bottom: 0; height: calc(100vh - 80px)">
      
      <div class="bg-white mt-4 rounded-20 px-2 py-4">
        <table class="table table-striped table-bordered ">
          <thead class="thead-secondary">
            <tr>
              <th>Сургалтын зар</th>
              <th>Багш</th>
              <th>Сургалтын нэр</th>
              <th>Эхлэх хугацаа</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t,i) in tasks" :key="i">
              <td>{{ t.task }}</td>
              <td>{{ t.taskEn }}</td>
              <td>{{ t.st1 }}</td>
              <td>{{ t.d1 | moment('YYYY.MM.DD /dddd/') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
    
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";
import { localSave, localRead } from "@/libs/util";

export default {
  components: {
    vueCustomScrollbar,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data() {
    return {
      tasks: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 200,
          ot: 609,
          model: {
            isPublic: true,
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    },
  },
};
</script>
